import useSWR from 'swr';
import { keyBy } from 'lodash';

import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import { GlobalLink } from '../../domain/static-content/static-content.static-generation.model';
import { getLocale } from '../../util/locales/locales';
import { Locale } from '../../util/locales/locale.model';

export const useRefreshLinks = (links: { id: string; fallback?: GlobalLink }[], locale?: Locale, enabled = true) => {
  const _locale = locale ?? getLocale();
  const linksIds = links.map(({ id }) => id);
  const linksFallbacks = links.map(({ fallback }) => fallback);

  const { fetcher: linksByIdsFetcher, key: linksByIdsKey } = StaticContentApiService.getLinksByIdsFetcher(linksIds, _locale);

  const { data: linkCollection } = useSWR(enabled && linksByIdsKey, linksByIdsFetcher, { fallbackData: linksFallbacks });

  return keyBy(linkCollection, 'id');
};
